import { useState } from "react";

import { Box, Button, IconButton } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import { isString } from "lodash";

import {
  BasicDialog,
  BasicDialogActions,
  BasicDialogContent,
  BasicDialogTitle,
} from "components/Dialog/BasicDialog";
import { useTranslations } from "hooks";

import { IInputOption } from "../BaseOptionsContainer";
import InputDate from "../InputDate/InputDate";
import { mapDatesToSelectOptions } from "./utils";

type TDate = Date | null | string;
type TOption = IInputOption<TDate>;
interface ICreateDateDialogProps {
  open: boolean;
  defaultOption: IInputOption<TDate>;
  onSave: (value: TOption) => void;
  onClose: () => void;
  format?: string;
  returnFormatted?: boolean;
}

const CreateDateDialog = ({
  onClose,
  onSave,
  defaultOption,
  open,
  format = "yyyy-MM-dd",
  returnFormatted = false,
}: ICreateDateDialogProps) => {
  const lang = useTranslations();
  const dateLabel = lang.periods.date;

  const [option, setOption] = useState(defaultOption);

  const onClickConfirm = () => {
    onSave(option);
    onClose();
  };

  const defaultValue = isString(option.value)
    ? new Date(option.value)
    : option.value;

  return (
    <BasicDialog open={open ?? false} minWidth={800} maxWidth={800}>
      <BasicDialogTitle>
        <Box display={"flex"}>
          <Box flexGrow={3}>{dateLabel}</Box>
          <Box flexGrow={0}>
            <IconButton onClick={onClose}>
              <Close />
            </IconButton>
          </Box>
        </Box>
      </BasicDialogTitle>

      <BasicDialogContent>
        <InputDate
          viewMode="CREATE"
          required
          name={`date`}
          defaultValue={defaultValue}
          onChange={(date) => {
            const dateOptions = mapDatesToSelectOptions(
              [date],
              format,
              returnFormatted,
            );

            const dateValue = dateOptions[0].value;
            setOption((option) => ({
              ...option,
              label: dateValue,
              value: dateValue,
            }));
          }}
          lang={{ title: dateLabel }}
        />
      </BasicDialogContent>

      <BasicDialogActions>
        <Button onClick={onClose} data-testid="cancel-button">
          {lang.genericTerms.cancel}
        </Button>
        <Button
          color="secondary"
          variant="contained"
          disableElevation
          onClick={onClickConfirm}
          data-testid="save-button"
        >
          {lang.genericTerms.save}
        </Button>
      </BasicDialogActions>
    </BasicDialog>
  );
};

export default CreateDateDialog;
